export enum PanelPosition {
  Leading = "leading",
  Trailing = "trailing",
}

export enum PanelOrientation {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

// Constants
export const IN_BETWEEN_SPACE = 1;
export const DEFAULT_MIN_SIZE = 100;
